<p-dialog  (onShow)='onShow()' (onHide)="onHide()" header="Importer Liste clients" [(visible)]="visible">
    <p-table #dt [columns]="cols" [loading]="loading" [value]="clients" sortField="dateEdit" [sortOrder]="-1">
        <ng-template pTemplate="caption">
            <p-toggleButton [(ngModel)]="isArchive" onLabel="Archive " (onChange)='onChange()' offLabel="Ancien clients" onIcon="pi-check" offIcon="pi pi-times" [style]="{'width': '10em'}"></p-toggleButton>

        </ng-template>



        <ng-template pTemplate="header" let-colsVaraible>
            <tr>
                <th *ngFor="let col of colsVaraible" [style.width]="col.width">
                    {{col.header}}
                </th>
                <th style="width: 100px;">Fiche Client</th>

            </tr>




            <tr>
                <th *ngFor="let col of cols" [ngSwitch]="col.field">

                    <p-dropdown *ngSwitchCase="'type'" [options]="types" [style]="{'width':'100%'}"
                        (onChange)="dt.filter($event.value, col.field, 'equals')"></p-dropdown>
                    <input style="width:100% ;" *ngSwitchDefault pInputText type="text"
                        (input)="dt.filter($event.target.value, col.field, 'contains')">

                </th>




                <th style="width: 100px;"> </th>
            </tr>

        </ng-template>
        <ng-template pTemplate="body" let-row let-colsVaraible="columns">
            <tr>


                <td *ngFor="let col of colsVaraible" [ngSwitch]="col.field">
                    <span *ngSwitchCase="'dateEdit'"> {{row[col.field] | date }}</span>
                    <span *ngSwitchCase="'type'">{{convertType(row[col.field])}} </span>
                    <span *ngSwitchDefault> {{row[col.field]}}</span>
               
                </td>


                <td>
                    <button (click)="getClientAncienErp(row)" class="btn btn-default">Importer</button>
                </td>



            </tr>
        </ng-template>


    </p-table>
</p-dialog>